export default __webpack_public_path__ + "static/19_32-a5f3799b7f11d4cdf821e3a46ae955f1.png";